<template>
  <div class="onboarding-card text-center">
    <img src="/images/onboarding/logo-terrazon.svg" alt="Terrazon" class="ob-logo-img" />
    <p class="ob-subtitle mt-3">Verifica tu número celular</p>
    <p class="ob-text">
      Hemos enviado un código de 4 dígitos a tu número vía WhatsApp<br />
      <strong>{{ whatsappMostrado }}</strong>
    </p>

    <div class="ob-otp-group my-4">
      <input
        v-for="(d, i) in digitos"
        :key="i"
        :ref="`otp${i}`"
        v-model="digitos[i]"
        type="tel"
        inputmode="numeric"
        maxlength="1"
        class="ob-otp-box"
        :class="{ 'is-invalid': !!errorMsg }"
        :disabled="loading"
        @input="onInput(i, $event)"
        @keydown="onKeydown(i, $event)"
      />
    </div>

    <p v-if="loading" class="ob-text"><span class="spinner-border spinner-border-sm me-2"></span>Verificando...</p>
    <p v-else-if="errorMsg" class="ob-error">{{ errorMsg }}</p>

    <button type="button" class="btn ob-btn-link" :disabled="loading" @click="$emit('reenviar')">
      Solicitar un nuevo código
    </button>

    <p class="ob-footer">GRUPO TERRAZON SAPI DE CV</p>
  </div>
</template>

<script>
export default {
  name: 'PantallaOtp',
  props: {
    loading: { type: Boolean, default: false },
    errorMsg: { type: String, default: '' },
    whatsappMostrado: { type: String, default: '' },
  },
  data() {
    return {
      digitos: ['', '', '', ''],
    };
  },
  watch: {
    errorMsg(nuevo) {
      if (nuevo) {
        this.digitos = ['', '', '', ''];
        this.$nextTick(() => this.foco(0));
      }
    },
  },
  mounted() {
    this.foco(0);
  },
  methods: {
    foco(i) {
      const el = this.$refs[`otp${i}`];
      if (el && el[0]) el[0].focus();
    },
    onInput(i, e) {
      const valor = e.target.value.replace(/\D/g, '').slice(-1);
      this.digitos.splice(i, 1, valor);
      e.target.value = valor;

      if (valor && i < 3) {
        this.foco(i + 1);
      }

      if (this.digitos.every((d) => d !== '')) {
        this.$emit('verificar', this.digitos.join(''));
      }
    },
    onKeydown(i, e) {
      if (e.key === 'Backspace' && !this.digitos[i] && i > 0) {
        this.foco(i - 1);
      }
    },
  },
};
</script>
